// This system was originally built as script elements in a browser, so we use
// `require` to force synchronous evaluation of each library
require('sockjs/sockjs.js');
window.$ = window.jQuery = require('jquery');
require('jquery-ui/jquery-ui.js');
require('angular/angular.js');
require('./vendor/angular-sanitize/angular-sanitize-1.2.1.js');
require('angular-animate/angular-animate.js');
require('angular-loading-bar/src/loading-bar.js');
require('angular-route/angular-route.js');
require('angular-ui-sortable/sortable.js');
// Prevent `seiyria-bootstrap-slider` from complaining about co-existing with jquery-ui's slider
$.fn.slider = null;
require('seiyria-bootstrap-slider/dist/bootstrap-slider.js');
require('bootstrap/js/collapse.js');
require('bootstrap/js/transition.js');
require('bootstrap/js/modal.js');
require('bootstrap/js/tooltip.js');
require('lodash/dist/lodash.js');
require('angular-ui-select/dist/select.js');
require('./vendor/powerange/powerange.js');
var ClipboardJS = require('clipboard/dist/clipboard.js');
(function() {
	function showTooltip(elem, msg) {
		var wrapper = $(elem).parent();
		var removeClass = function() {
			wrapper.removeClass('hint--always hint--right hint--no-animate hint--rounded');
		};
		var timeout = setTimeout(removeClass, 2000);
		wrapper.attr('data-hint', msg).addClass('hint--always hint--right hint--no-animate hint--rounded').on('mouseout', function() {
			removeClass();
			clearTimeout(timeout);
		});
	}

	$(document).on('click', '.main-nav__link.new-game', function () {
		// Before navigating to /new/, terminate the websocket so no pointless reconnect is
		// attempted before we navigate away.
		if (window.syrinscape) {
			window.syrinscape.player.socketSystem.terminate()
		}
	})

	var clipboard = new ClipboardJS('.api-links i.fas')
	clipboard.on('success', function(event) {
		if (event.text) {
			showTooltip(event.trigger, 'Copied!');
		}
	});

	document.addEventListener('DOMContentLoaded', function () {
		var modalClipboard = new ClipboardJS('#main-nav-modal .share-audio', {
			container: document.getElementById('main-nav-modal'),
		})
		modalClipboard.on('success', function (event) {
			if (event.text) {
				showTooltip(event.trigger, 'Copied!')
			}
		})

		// Simple slide toggle
		// TODO: DRY this up - copied from `website-rebuild-2021/js/main.js`
		$('.js-slide-toggle').each(function () {
			var buttonID = uniqueID()
			var paneID = uniqueID()

			$(this).attr('id', buttonID)
			$(this).attr('aria-controls', paneID)
			$(this).parent().next().attr('id', paneID)
			$(this).parent().next().attr('aria-labelledby', buttonID)
			$(this).parent().next().addClass('js-slide-toggle-pane')

			if ($(this).hasClass('is-open')) {
				$(this).attr('aria-expanded', 'true')
				$(this).parent().next().attr('aria-expanded', 'true')
			} else {
				$(this).attr('aria-expanded', 'false')
				$(this).parent().next().attr('aria-expanded', 'false')
				$(this).parent().next().attr('role', 'region')
				$(this).parent().next().hide()
			}
		})

		$('.js-slide-toggle').click(function () {
			$(this).toggleClass('is-open')
			$(this).parent().next().toggleClass('is-open')
			$(this).parent().next().slideToggle(0)

			if ($(this).hasClass('is-open')) {
				$(this).attr('aria-expanded', 'true')
				$(this).parent().next().attr('aria-expanded', 'true')
			} else {
				$(this).attr('aria-expanded', 'false')
				$(this).parent().next().attr('aria-expanded', 'false')
			}
		})
	})

	function uniqueID() {
		return '_' + Math.random().toString(36).substr(2, 9);
	};
})();

// IE11 compatibility
require('es6-promise').polyfill();

window.Sentry = require('@sentry/browser');
const SentryIntegrations = require('@sentry/integrations');
if (context.SENTRY_DSN) {
	Sentry.init({
		dsn: context.SENTRY_DSN,
		integrations: [
			// Injects the ngSentry module that hooks into Angular's lifecycle. Note that this
			// must be defined after the angular lib is executed as it requires access to the
			// Angular's global variable
			new SentryIntegrations.Angular(),
			new SentryIntegrations.CaptureConsole({
				// array of methods that should be captured
				// defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
				levels: ['error', 'assert'],
			}),
			new SentryIntegrations.ExtraErrorData({
				// Limit of how deep the object serializer should go. Anything deeper than limit will
				// be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
				// a primitive value. Defaults to 3.
				depth: 3,
			}),
			new SentryIntegrations.Offline({
				// limit how many events will be saved locally. Defaults to 30.
				maxStoredEvents: 128,
			}),
		],
	});
	Sentry.syrinscape = true
}

require('./app.js');
require('./services.js');
require('./controllers.js');
require('./filters.js');
require('./directives.js');



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/index.js